import { render, staticRenderFns } from "./UserInfoBlocksTable.vue?vue&type=template&id=0342afba&scoped=true"
import script from "./UserInfoBlocksTable.vue?vue&type=script&lang=js"
export * from "./UserInfoBlocksTable.vue?vue&type=script&lang=js"
import style0 from "./UserInfoBlocksTable.vue?vue&type=style&index=0&id=0342afba&prod&lang=css"
import style1 from "./UserInfoBlocksTable.vue?vue&type=style&index=1&id=0342afba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0342afba",
  null
  
)

export default component.exports